// Information Technology Skills organized by subcategories
export const INFORMATION_TECHNOLOGY_SKILLS_CATEGORIES = [
  {
    name: 'Software Development',
    skills: [
      'Programming Languages', 'Object-Oriented Programming', 'Web Development',
      'Mobile Development', 'API Development', 'Software Architecture',
      'Version Control', 'Code Review', 'Testing Frameworks',
      'Debugging', 'Continuous Integration', 'DevOps Practices',
      'Microservices', 'Serverless Computing', 'Software Design Patterns'
    ]
  },
  {
    name: 'Database Management',
    skills: [
      'SQL', 'Database Design', 'Data Modeling',
      'Database Administration', 'Query Optimization', 'Data Migration',
      'NoSQL Databases', 'Database Security', 'Backup and Recovery',
      'Data Warehousing', 'ETL Processes', 'Database Performance Tuning',
      'Replication', 'Indexing Strategies', 'Database Monitoring'
    ]
  },
  {
    name: 'Network Administration',
    skills: [
      'Network Protocols', 'Network Security', 'Routing and Switching',
      'Firewall Management', 'VPN Configuration', 'Network Monitoring',
      'Load Balancing', 'DNS Management', 'Network Troubleshooting',
      'Wireless Networks', 'Network Design', 'Traffic Analysis',
      'Network Performance', 'VoIP Systems', 'Network Documentation'
    ]
  },
  {
    name: 'Cloud Computing',
    skills: [
      'AWS', 'Azure', 'Google Cloud',
      'Cloud Architecture', 'Cloud Security', 'Container Orchestration',
      'Cloud Storage', 'Serverless Computing', 'Cloud Migration',
      'Cost Optimization', 'High Availability', 'Disaster Recovery',
      'Multi-Cloud Strategy', 'Cloud Monitoring', 'Auto Scaling'
    ]
  },
  {
    name: 'Cybersecurity',
    skills: [
      'Security Protocols', 'Penetration Testing', 'Vulnerability Assessment',
      'Incident Response', 'Security Auditing', 'Access Control',
      'Encryption', 'Security Tools', 'Threat Analysis',
      'Security Compliance', 'Risk Management', 'Security Architecture',
      'Malware Analysis', 'Digital Forensics', 'Security Awareness'
    ]
  },
  {
    name: 'System Administration',
    skills: [
      'Linux Administration', 'Windows Server', 'Server Management',
      'System Monitoring', 'Patch Management', 'User Administration',
      'Shell Scripting', 'Virtualization', 'Storage Management',
      'Backup Solutions', 'Performance Tuning', 'Service Management',
      'Configuration Management', 'System Security', 'Documentation'
    ]
  },
  {
    name: 'Data Analytics',
    skills: [
      'Data Analysis', 'Business Intelligence', 'Data Visualization',
      'Statistical Analysis', 'Machine Learning', 'Big Data Technologies',
      'Data Mining', 'Predictive Analytics', 'Data Cleaning',
      'Report Generation', 'Dashboard Creation', 'Data Integration',
      'Analytics Tools', 'Data Modeling', 'Performance Metrics'
    ]
  },
  {
    name: 'Project Management',
    skills: [
      'Agile Methodologies', 'Scrum', 'Project Planning',
      'Risk Management', 'Resource Allocation', 'Stakeholder Management',
      'Quality Assurance', 'Change Management', 'Project Documentation',
      'Team Leadership', 'Budget Management', 'Timeline Management',
      'Project Tracking', 'Communication', 'Problem Solving'
    ]
  },
  {
    name: 'UI/UX Design',
    skills: [
      'User Interface Design', 'User Experience Design', 'Wireframing',
      'Prototyping', 'Usability Testing', 'Responsive Design',
      'Design Systems', 'Information Architecture', 'Visual Design',
      'Interaction Design', 'Mobile Design', 'Accessibility',
      'User Research', 'Design Tools', 'Design Thinking'
    ]
  },
  {
    name: 'DevOps',
    skills: [
      'Continuous Integration', 'Continuous Deployment', 'Infrastructure as Code',
      'Configuration Management', 'Container Management', 'Automation',
      'Monitoring and Logging', 'Performance Optimization', 'Release Management',
      'Version Control', 'Build Tools', 'Deployment Strategies',
      'Pipeline Design', 'Security Integration', 'Collaboration'
    ]
  },
  {
    name: 'Mobile Development',
    skills: [
      'iOS Development', 'Android Development', 'Cross-Platform Development',
      'Mobile UI Design', 'App Security', 'Performance Optimization',
      'Mobile Testing', 'API Integration', 'Push Notifications',
      'Mobile Analytics', 'App Store Deployment', 'Mobile Frameworks',
      'Responsive Design', 'Mobile Architecture', 'User Authentication'
    ]
  },
  {
    name: 'Quality Assurance',
    skills: [
      'Test Planning', 'Test Automation', 'Manual Testing',
      'Performance Testing', 'Security Testing', 'Regression Testing',
      'Unit Testing', 'Integration Testing', 'Test Documentation',
      'Bug Tracking', 'Test Frameworks', 'Load Testing',
      'User Acceptance Testing', 'Test Strategy', 'Quality Standards'
    ]
  },
  {
    name: 'Enterprise Systems',
    skills: [
      'ERP Systems', 'CRM Systems', 'Business Process Management',
      'Enterprise Architecture', 'System Integration', 'Workflow Automation',
      'Enterprise Security', 'Data Governance', 'Compliance Management',
      'Legacy System Migration', 'Enterprise Storage', 'Identity Management',
      'Enterprise Monitoring', 'Disaster Recovery', 'Change Management'
    ]
  },
  {
    name: 'Artificial Intelligence',
    skills: [
      'Machine Learning', 'Deep Learning', 'Natural Language Processing',
      'Computer Vision', 'Neural Networks', 'AI Frameworks',
      'Model Training', 'Data Preprocessing', 'Algorithm Development',
      'Feature Engineering', 'Model Optimization', 'AI Ethics',
      'Reinforcement Learning', 'AI Integration', 'Performance Analysis'
    ]
  },
  {
    name: 'Blockchain',
    skills: [
      'Blockchain Development', 'Smart Contracts', 'Cryptocurrency',
      'Distributed Systems', 'Consensus Mechanisms', 'Blockchain Security',
      'DApp Development', 'Token Economics', 'Blockchain Platforms',
      'Cryptography', 'Network Protocols', 'Blockchain Architecture',
      'Wallet Integration', 'Chain Analysis', 'Governance Models'
    ]
  }
];

// Export flattened list for backward compatibility
export const INFORMATION_TECHNOLOGY_SKILLS = INFORMATION_TECHNOLOGY_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
